/* eslint-disable react/require-default-props */
import React from 'react';
import { IssueStatusEnum } from '@features/IIMReview/types';
import { Accordion } from '@ui/molecules/Accordion/Accordion';
import { translate } from '@utils/i18n';
import IssueCardHeader from './IssueCardHeader';
import IssueTags from './IssueTags';
import './styles.scss';
/**
 * Shared layout component for all issue card types
 * Includes the header and expandable body section
 */
export default function IssueLayout({ issueType, badge, status, defaultExpanded, onToggle, onSuggestCorrection, onDismissIssue, onUndoAction, readOnly, children, statusChanges, isMultitech, technician, markedForSuggestion, hideSuggestCorrection = false, onResolveDeficiency, onReopenDeficiency }) {
    const headerContent = (React.createElement(IssueCardHeader, { issueType: issueType, badge: badge, isMultitech: isMultitech, technician: technician }));
    // Preview content - TagsList shown when collapsed
    const previewContent = React.createElement(IssueTags, { statusChanges: statusChanges, isPreview: true });
    // Build actions based on issue status
    const actions = [];
    if ([IssueStatusEnum.Resolved, IssueStatusEnum.DismissedByBackOffice, IssueStatusEnum.Suggested].includes(status) ||
        markedForSuggestion) {
        if (markedForSuggestion) {
            // Show undo button
            actions.push({
                icon: null,
                label: translate('correction_suggested', { namespace: 'features.iim_review.issue_card' }),
                buttonProps: {
                    className: 'issue-card__status issue-card__status--suggested',
                    disabled: true
                }
            });
        }
        // Show undo button
        actions.push({
            icon: React.createElement("i", { className: "fa-light fa-arrows-repeat" }),
            label: translate('undo', { namespace: 'features.iim_review.issue_card' }),
            buttonProps: {
                onClick: onUndoAction,
                disabled: readOnly
            }
        });
    }
    else {
        // Show normal actions
        if (onReopenDeficiency) {
            actions.push({
                icon: React.createElement("i", { className: "fa-light fa-rotate-left" }),
                label: translate('reopen', { namespace: 'features.iim_review.issue_card' }),
                buttonProps: {
                    onClick: onReopenDeficiency,
                    disabled: readOnly
                }
            });
        }
        if (onResolveDeficiency) {
            actions.push({
                icon: React.createElement("i", { className: "fa-light fa-check-circle" }),
                label: translate('resolve_deficiency', { namespace: 'features.iim_review.issue_card' }),
                buttonProps: {
                    onClick: onResolveDeficiency,
                    disabled: readOnly
                }
            });
        }
        if (!hideSuggestCorrection) {
            actions.push({
                icon: React.createElement("i", { className: "fa-light fa-message-lines" }),
                label: translate('suggest_correction', { namespace: 'features.iim_review.issue_card' }),
                buttonProps: {
                    onClick: onSuggestCorrection,
                    disabled: readOnly
                }
            });
        }
        actions.push({
            icon: React.createElement("i", { className: "fa-light fa-xmark" }),
            label: translate('dismiss', { namespace: 'features.iim_review.issue_card' }),
            buttonProps: {
                onClick: onDismissIssue,
                disabled: readOnly
            }
        });
    }
    return (React.createElement(Accordion, { title: headerContent, previewContent: previewContent, defaultExpanded: defaultExpanded, onToggle: onToggle, actions: actions, className: "issue-card-accordion" },
        React.createElement("div", { className: "issue-card__body" },
            React.createElement(IssueTags, { statusChanges: statusChanges }),
            children)));
}
